import styled from 'styled-components';
import { Z_INDEX } from '../../styles/variables';

interface DrawerContainerProps {
    $collapsedWidth: number;
}

export const DrawerContainer = styled.div<DrawerContainerProps>`
    min-width: ${({ $collapsedWidth }) => $collapsedWidth}px;
    height: 100%;
    position: relative;
    z-index: ${Z_INDEX.NAVBAR + 10};
`;

interface Props {
    open: boolean;
    isPinned: boolean;
    collapsedWidth: number;
    expandedWidth: number;
    isExpanded: boolean;
    isSkipHover: boolean;
}

export const DrawerWrapper = styled.div<Props>`
    position: ${({ isPinned }) => (isPinned ? 'static' : 'absolute')};
    display: flex;
    z-index: ${Z_INDEX.POPOVER};
    height: 100%;
    width: ${({ isPinned, collapsedWidth, expandedWidth, open }) => {
        if (open === undefined) {
            return isPinned ? expandedWidth : collapsedWidth;
        }
        return open ? expandedWidth : collapsedWidth;
    }}px;
    transition: width 200ms cubic-bezier(0.77, 0, 0.175, 1) 150ms;

    &:hover {
        width: ${({ isPinned, expandedWidth, collapsedWidth }) =>
            isPinned ? expandedWidth : collapsedWidth}px;
    }

    ${({ isPinned, isSkipHover, expandedWidth, open }) => {
        if (isPinned || isSkipHover || open === false) {
            return;
        }

        return `
            &:hover {
                width: ${expandedWidth}px;
            }
        `;
    }}
`;
